import React, { useId } from 'react';
import { ringTier, RING_GRADIENT_STOPS } from './designHelpers';

export default function RatingRing({ rating, size = 28 }) {
  const gradId = useId();
  if (rating === null || rating === undefined) return <span className="mtn-ring-empty">—</span>;

  const r = 14.5;
  const c = 2 * Math.PI * r;
  const pct = Math.max(0, Math.min(1, rating / 10));
  const offset = c * (1 - pct);
  const tier = ringTier(rating);
  const [from, to] = RING_GRADIENT_STOPS[tier];

  return (
    <div className={`mtn-ring ${tier}`}>
      <svg width={size} height={size} viewBox="0 0 36 36">
        <defs>
          <linearGradient id={gradId} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
        <circle className="mtn-ring-track" cx="18" cy="18" r={r} />
        <circle
          className="mtn-ring-fill"
          cx="18" cy="18" r={r}
          stroke={`url(#${gradId})`}
          strokeDasharray={c}
          strokeDashoffset={offset}
        />
      </svg>
      <div className="mtn-ring-val">{rating}</div>
    </div>
  );
}
